import { render, staticRenderFns } from "./LightHeader.vue?vue&type=template&id=b315e56c"
import script from "./LightHeader.vue?vue&type=script&lang=js"
export * from "./LightHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports